import React, { useState } from "react";
import { colors } from "../../../../../../../../../themes/Colors";
import BaseButtons from "../../../../../../../base-buttons/BaseButtons";
import ImageUploadAWS from "../../../../../../../../user/components/image-upload/ImageUploadAWS";
import TextInputFieldArea from "../../../../../../../text-input-field/TextInputFieldArea";
import TextInputField from "../../../../../../../text-input-field/TextInputField";
import CheckInput from "../../../../../../../check-input/CheckInput";

const validFileTypes = ["image/jpg", "image/jpeg", "image/png"];

const AddPopUp = ({ display, onCloseClick, name }) => {
  const [image, setImage] = useState(null);
  const [imageError, setImageError] = useState(null);

  const [requestDate, setRequestDate] = useState("");
  const [requestTime, setRequestTime] = useState("");
  const [vehicleLiscenseNr, setVehicleLiscenseNr] = useState("");
  const [make, setMake] = useState("");
  const [series, setSeries] = useState("");
  const [vehicleColor, setVehicleColor] = useState("");

  const [windScreenCracks, setWindScreenCracks] = useState(false);
  const [mechanicalRepairs, setMechanicalRepairs] = useState(false);
  const [serviceDue, setServiceDue] = useState(false);
  const [frontTyres, setFrontTyres] = useState(false);
  const [rearTyres, setRearTyres] = useState(false);
  const [accident, setAccident] = useState(false);

  const [terms, setTerms] = useState(false);

  const handleFileChange = (e) => {
    // Uploaded file
    const file = e.target.files[0];
    // Changing file state
    setImage(file);
  };
  return (
    <div
      style={{
        position: "fixed",
        width: "100%",
        height: display ? "100%" : 0,
        backgroundColor: colors.white,
        zIndex: 20,
        top: 0,
        overflowY: display ? "scroll" : "hidden",
        overflowX: display ? "scroll" : "hidden",
        transition: "all 0.2s",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: 20,
          top: 30,
          display: "flex",
          alignItems: "center",
        }}
      >
        {" "}
        <div
          onClick={onCloseClick}
          style={{
            height: 60,
            width: 90,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: 2,
            borderColor: colors.white,
            transition: "all 0.3s",
            WebkitBoxShadow: "-5px 5px 15px -1px #00000070",

            borderBottomRightRadius: 10,
            borderBottomLeftRadius: 10,
            backgroundColor: colors.orangeDark,
          }}
        >
          <div
            style={{
              marginTop: 10,
              fontWeight: "bold",
              color: colors.white,
              transition: "all 0.3s",
            }}
          >
            BACK
          </div>
        </div>
        <div
          style={{
            marginTop: 10,
            marginLeft: 20,
            fontWeight: "bold",
            fontSize: 18,
          }}
        >
          SELL MY VEHICLE
        </div>
      </div>
      {/* main page dtata and view */}
      <div
        style={{
          flex: 1,
          height: "100%",
          overflowY: "hidden",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={{ minHeight: 100, width: "100%" }} />
        <div
          style={{
            flex: 1,
            height: "100%",
            overflowY: "hidden",
            overflowX: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* <div style={{ minHeight: 100, width: "100%" }} /> */}
          <div
            style={{
              flex: 1,
              overflowY: "scroll",
              overflowX: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <TextInputField
              labelTitle={"Request Date"}
              mini={true}
              width={"100%"}
              size={"80%"}
              value={requestDate}
              onChange={(e) => setRequestDate(e.target.value)}
            />
            <TextInputField
              labelTitle={"Request Time"}
              mini={true}
              width={"100%"}
              size={"80%"}
              value={requestTime}
              onChange={(e) => setRequestTime(e.target.value)}
            />
            <TextInputField
              labelTitle={"Liscense nr"}
              mini={true}
              width={"100%"}
              size={"80%"}
              value={vehicleLiscenseNr}
              onChange={(e) => setVehicleLiscenseNr(e.target.value)}
            />
            <TextInputField
              labelTitle={"Make"}
              mini={true}
              width={"100%"}
              size={"80%"}
              value={make}
              onChange={(e) => setMake(e.target.value)}
            />
            <TextInputField
              labelTitle={"Series"}
              mini={true}
              width={"100%"}
              size={"80%"}
              value={series}
              onChange={(e) => setSeries(e.target.value)}
            />
            <TextInputField
              labelTitle={"Color"}
              mini={true}
              width={"100%"}
              size={"80%"}
              value={vehicleColor}
              onChange={(e) => setVehicleColor(e.target.value)}
            />
            <div
              style={{
                width: "100%",
                marginTop: 15,
                marginBottom: 15,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "80%",
                  textAlign: "left",
                  fontSize: 14,
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                VEHICLE DESCRIPTION{" "}
                <div
                  style={{ marginLeft: 10, fontSize: 12, fontWeight: "normal" }}
                >
                  Click only if yes
                </div>
              </div>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <div style={{ width: "80%", marginBottom: 10 }}>
                <CheckInput
                  selected={windScreenCracks}
                  label={"Is there any chips and cracks on the windscreen?"}
                  onClick={() =>
                    setWindScreenCracks(windScreenCracks ? false : true)
                  }
                />
              </div>
              <div style={{ width: "80%", marginBottom: 10 }}>
                {" "}
                <CheckInput
                  selected={mechanicalRepairs}
                  label={"Does the vehicle require any mechanical repairs?"}
                  onClick={() =>
                    setMechanicalRepairs(mechanicalRepairs ? false : true)
                  }
                />
              </div>
              <div style={{ width: "80%", marginBottom: 10 }}>
                <CheckInput
                  selected={serviceDue}
                  label={"Does the vehicle have a service due?"}
                  onClick={() => setServiceDue(serviceDue ? false : true)}
                />
              </div>
              <div style={{ width: "80%", marginBottom: 10 }}>
                <CheckInput
                  selected={frontTyres}
                  label={"Does the front tyre need to be replaced?"}
                  onClick={() => setFrontTyres(frontTyres ? false : true)}
                />
              </div>

              <div style={{ width: "80%", marginBottom: 10 }}>
                <CheckInput
                  selected={rearTyres}
                  label={"Does the rear tyre need to be replaced?"}
                  onClick={() => setRearTyres(rearTyres ? false : true)}
                />
              </div>
              <div style={{ width: "80%", marginBottom: 10 }}>
                <CheckInput
                  selected={accident}
                  label={"Was the vehicle ever involved in an accident?"}
                  onClick={() => setAccident(accident ? false : true)}
                />
              </div>
            </div>
            <TextInputFieldArea
              mini={true}
              labelTitle={"ADDITIONAL INFO"}
              height={100}
              width={"100%"}
              size={"80%"}
            />
            <TextInputFieldArea
              mini={true}
              labelTitle={"Reason for vehicle sale?"}
              height={100}
              width={"100%"}
              size={"80%"}
            />
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                minHeight: 230,
              }}
            >
              <div style={{ width: "80%", marginBottom: 10 }}>
                <CheckInput
                  selected={terms}
                  label={
                    "By continuing, I confirm that the information I have provided about the vehicle is accurate, agree to the applicable fees and terms for selling the vehicle, consent to sharing my data with third-party agents, acknowledge the terms of use, liability limitations, cancellation, and refund policies as outlined in the Drivers Friend Terms & Conditions and Privacy Policy, and understand that the type of deal (cash offer, trade-in, wholesale, etc.) and expected price may vary based on market conditions and vehicle evaluation."
                  }
                  onClick={() => setTerms(terms ? false : true)}
                />
              </div>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                marginBottom: 20,
              }}
            >
              <BaseButtons
                label={"Select Agency"}
                width={"80%"}
                borderRadius={8}
                backgroundColor={colors.greenDark}
              />
            </div>
            <ImageUploadAWS
              onChange={(e) => handleFileChange(e)}
              labelTitle={"Upload Motor Vehicle Documents"}
              mini={true}
              errorDisplay={imageError}
              width={"100%"}
              size={"80%"}
            />
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
                marginTop: 20,
                marginBottom: 20,
              }}
            >
              <BaseButtons
                label={"CANCEL"}
                backgroundColor={colors.orangeDark}
                width={"40%"}
                borderRadius={8}
                onClick={onCloseClick}
              />
              <BaseButtons
                label={"SUBMIT"}
                backgroundColor={colors.greenDark}
                width={"40%"}
                borderRadius={8}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPopUp;
